import React from 'react';
import Notification from '../../Notification';
import { FormattedMessage } from 'react-intl';
import Span from '../../tag/Span';
import Row from '../../tag/Row';
import OTButton from '../../tag/OTButton';

let { id: module_id } = module;

const NoReservableAppointmentsNotification = ({ clinic, history }) => {
  return (
    <Notification>
      <Row>
        <Span>
          <span style={{ fontWeight: 700 }}>
            <FormattedMessage id={`${module_id}.title`} />
          </span>
        </Span>
      </Row>
      <Row>
        <Span>
          <FormattedMessage
            id={`${module_id}.description${clinic ? '.' + clinic : ''}`}
          />
        </Span>
      </Row>
      <Row style={{ marginTop: '10px' }}>
        <Span len="3">
          <OTButton
            onClick={() => history.push('/appointments')}
            message={'back'}
            type={'big'}
            color={'light'}
          />
        </Span>
      </Row>
    </Notification>
  );
};

export default NoReservableAppointmentsNotification;
